import { render, staticRenderFns } from "./FileUploaderRevision.vue?vue&type=template&id=23b3e125&scoped=true"
import script from "./FileUploaderRevision.vue?vue&type=script&lang=js"
export * from "./FileUploaderRevision.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderRevision.vue?vue&type=style&index=0&id=23b3e125&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3e125",
  null
  
)

export default component.exports